import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../../hooks/useNotifications'
import { redactMessage } from '../../../../services/chatService'

export default function RedactSelectedMessagesOverlay({ selectedMessages, updateRedactedMessagesList, ...overlay }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()
  const readyToDeleteMessages = selectedMessages.map((message) => message.replace('-messageInQuestion', ''))

  const submitOnClick = async () => {
    overlay.close()
    try {
      const redactMessageResponses = await Promise.allSettled(
        readyToDeleteMessages.map((message) => {
          const messageRedactPayload = {
            messageRedactList: [{ messageId: message }],
          }
          return redactMessage(messageRedactPayload)
        })
      )
      const successfullyRedactedMessageIds = []
      const failedToRedactMessageIds = []
      redactMessageResponses.forEach((response) => {
        if (response.status === 'rejected') {
          const data = JSON.parse(response.reason.config.data)
          const messageId = data.messageRedactList[0].messageId
          failedToRedactMessageIds.push(messageId)
        } else {
          const data = JSON.parse(response.value.config.data)
          const messageId = data.messageRedactList[0].messageId
          successfullyRedactedMessageIds.push(messageId)
        }
      })
      if (readyToDeleteMessages.length === failedToRedactMessageIds.length) {
        error(t('user.messages.redactAllSelectedMessagesFailure', 'Failed to redact selected messages'))
      } else if (failedToRedactMessageIds.length > 0) {
        error(
          `${t('user.messages.redactSelectedMessagesFailure', {
            defaultValue: `Failed to redact messages`,
          })}: ${JSON.stringify(failedToRedactMessageIds)}`
        )
        updateRedactedMessagesList(successfullyRedactedMessageIds)
      } else {
        ok(t('user.messages.redactSelectedMessagesSuccess', 'Messages redacted'))
        updateRedactedMessagesList(successfullyRedactedMessageIds)
      }
    } catch (err) {
      error(
        `${t('user.messages.redactSelectedMessagesFailure', {
          defaultValue: `Failed to redact messages`,
        })}${err.message && `: ${err.message}`}`,
        err
      )
    }
  }

  return (
    <DialogOverlay title={t('action.redact', 'Redact')} {...overlay}>
      <Paragraph size="sm">
        {t('user.messages.redactSelectedMessagesConfirmation', 'Are you sure you want to redact these messages?')}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={submitOnClick} emphasis="high">
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
